export const baseUrl = "http://api.phonekadai.com/phonekadai"